;(function ($) {

	// //Facebook share settings
	// let doctorsId = 0;
	// let FBSharedUrl = document.location.origin+document.location.pathname+'?doctor_id='+doctor_id;

	var doctor_id, partner_id;
	var scroll_to_doctor_id;
	var fs,incognito=false, sent=false;

	$.ajaxPrefilter(function (options, originalOptions, xhr) { // this will run before each request
		var token = $('meta[name="csrf-token"]').attr('content'); // or _token, whichever you are using

		if (token) {
			return xhr.setRequestHeader('X-CSRF-TOKEN', token); // adds directly to the XmlHttpRequest Object
		}
	});

	function setLikesCount(elem) {
		var curr_elem = $(elem).find('.active.center .doctors-slider__slide');
		if (typeof curr_elem=='undefined') curr_elem = $(elem).find('.active .doctors-slider__slide');
		var active_cnt = curr_elem.data('cnt');
		$(elem).next('.circles').next('.innerlikes').text(active_cnt);
	}

	$(function () {

		fs = window.RequestFileSystem || window.webkitRequestFileSystem;
		if (!fs) {
  			console.log("check failed?");
		} else {
  			fs(window.TEMPORARY,
     		100,
     		function () {incognito=false},
     		function () {incognito=true});
		}



		if ($('.doctors-slider').length>0) {
			$('.doctors-slider').owlCarousel({
				center: true,
				items: 3,
				loop: true,
				margin: 20,
				navText: ['', ''],
				nav: true,
				dots: false,
				responsive: {
					0: {
						center: true,
						items: 1,
						loop: true,
						margin: 20,
						navText: ['', ''],
						nav: true,
						dots: false
					},
					641: {
						center: true,
						items: 3,
						loop: true,
						margin: 20,
						navText: ['', ''],
						nav: true,
						dots: false
					}
				}
			}).on('changed.owl.carousel', function(e) {
				setTimeout(function () {
					setLikesCount(e.target);
				}, 300);
			});

			$('.doctors-slider').each(function (ind, v) {
				setLikesCount(v);
			});
		}



		if (($('.nominations-slider').length>0) || ($('.doctor-box').length>0)) {

			//!TOOGLE NOMINATON DESCRIPTIONS
			const showMoreButtons = document.querySelectorAll('.nominations-desc__show-more');

			const hideNominationDescriptions = () => {
				showMoreButtons.forEach(button => button.dataset.status = 'hidden');
			}

			document.body.addEventListener('click', (e) => {

				if (e.target.dataset.type === 'show-more'){
					e.target.dataset.status != 'active'?
						e.target.dataset.status = 'active'
						: e.target.dataset.status = 'hidden';
				} else if ((e.target.dataset.type === 'desc') || (e.target.parentElement.dataset.type === 'desc')){
					return false;
				} else {
					//hide nominations descriptions
					hideNominationDescriptions();
				}
			})

			if ($('.nominations-slider').length>0) {
				$('.nominations-slider').owlCarousel({
					items: 1,
					loop:true,
					margin: 0,
					navText: ['',''],
					nav: true,
					dots: false,
					autoHeight:false
				}).on('changed.owl.carousel', function(e) {;

					//hide nominations descriptions
					hideNominationDescriptions();

					setTimeout(function () {
						//toggle nominant link
						var curr_ind = $('.nominations-slider .active .nominations-slider__slide').data('slide-no');
						$('.nominants__link').removeClass('nominants__link_active');
						$('.nominants__link[data-slide="'+curr_ind.toString()+'"]').addClass('nominants__link_active');
					}, 300);
				});


				//activate nominant link
				$('.nominants__link[data-slide="0"]').addClass('nominants__link_active');

				var ids={}, ids_urls=[];
				$('.nominations-slider__slide').each(function (ind, v) {
					var idurl = document.location.href+'?doctor_id='+$(v).data('doctor-id');
					if (typeof ids[idurl] == 'undefined') {
						ids[idurl]=$(v).data('doctor-id');
						ids_urls.push(idurl);
					}
				});

				scroll_to_doctor_id = document.location.search.split('&')[0].split('=')[1];
				if (typeof scroll_to_doctor_id!='undefined') {
					$('.nominations-slider').trigger('to.owl.carousel', $('.nominations-slider__slide[data-doctor-id="'+scroll_to_doctor_id+'"]').data('slide-no'));
				}
			}
		}





		if ($('.experts-carousel').length>0) {
			$('.experts-carousel').owlCarousel({
				center: true,
				items: 3,
				loop: true,
				margin: 15,
				navText: ['', ''],
				nav: true,
				dots: false,
				responsive: {
					0: {
						items: 1,
					},
					690: {
						items: 3,
					}
				}
			}).on('changed.owl.carousel', function (event) {
				setTimeout(function () {
					var htmlcontent = $('.experts-carousel .active.center .experts_hidden').html();
					$('.nominations__bottom-text').fadeOut(function () {
						$('.nominations__bottom-text').html(htmlcontent).fadeIn();
					});
				}, 300);
			});

			var htmlcontent = $('.experts-carousel .active.center .experts_hidden').html();
			$('.nominations__bottom-text').html(htmlcontent).fadeIn();
		}



		//!SLIDER: partners
		if ($('.partners__carousel.partners__carousel_partners').length>0) {

			if ($('.partner-desc').length>0)
				$('.partner-desc').html($('.partners__carousel.partners__carousel_partners .active.center .hidden-desc').html());

			$('.partners__carousel.partners__carousel_partners').owlCarousel({
				center: true,
				items: 1,
				loop: true,
				navText: ['',''],
				nav: true,
				dots: false,
				responsive: {
					640: {
						items: 3,
					},
				}
			}).on('changed.owl.carousel', function(event) {
				setTimeout(function () {
					if ($('.partner-desc').length>0) {
						var htmlcontent = $('.partners__carousel.partners__carousel_partners .active.center .hidden-desc').html();
						$('.partner-desc').fadeOut(function () {
							$('.partner-desc').html(htmlcontent).fadeIn();
						});
					}
				}, 300);

			});

			partner_id = document.location.search.split('=')[1];
			param_name = document.location.search.split('=')[0];
			if (typeof partner_id=='undefined') {
				$('.partners__carousel.partners__carousel_partners').trigger('to.owl.carousel', 0);
			}
			else {
				if (param_name=='?partner_id')
					$('.partners__carousel.partners__carousel_partners').trigger('to.owl.carousel', $('.partners__item[data-partner-id="'+partner_id+'"]').data('slide-no'));
				else
					$('.partners__carousel.partners__carousel_partners').trigger('to.owl.carousel', 0);
			}


		}
	});

	//! FACEBOOK SHARING
	if ($('.doctor-box').length>0){
		const shareFacebook = () => {

			var overrideUrl = document.location.href;
			var overrideTitle = "Голосуй за Найкращих медиків України 2019 за версією LIKAR.INFO";

			FB.ui({
				method: 'share_open_graph',
				action_type: 'og.shares',
				action_properties: JSON.stringify({
					object: {
						'og:url': overrideUrl,
						'og:title': overrideTitle,
					}
				})
				},
				// callback
				function(response) {
					if (response && !response.error_message) {
							// then get post content
							var fbcnt = parseInt($('.doctor-box .socicon__item_facebook').next('.nominations-counter').text());
							fbcnt++;
							$('.doctor-box .socicon__item_facebook').next('.nominations-counter').text(fbcnt);

					$.post('/special/best-likar-2019/vote/',{
						doctor_id: doctor_id,
						share: 1
					}, function (data) {
						console.log('fb-voted');
					});

					} else {
							console.log(response);
					}
			});
		}

		$(document).on('click', '.doctor-box .socicon__link_facebook', function (e) {
			e.preventDefault();
			shareFacebook();
		});

	}


//// list main slider to curent slide
// if ($('.nominations-slider').length>0){
// 	$(document).on('click', '.nominants__link', function (e) {
// 		e.preventDefault();
// 		$('.nominants__link').removeClass('nominants__link_active');
// 		$(this).addClass('nominants__link_active');
// 		$('.nominations-slider').trigger('to.owl.carousel', $(this).data('slide'));
// 	});
// }



	$(document).on('click', '.winners__link', function (e) {
		e.preventDefault();
		$(this).find('.flip-container').toggleClass('hover');
	});


	//!COOKIE FOR VOTING
	//*set cookie for voting
	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	//*get cookie for voting
	function getCookie(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
						c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
						return c.substring(name.length, c.length);
				}
		}
		return "";
	}


		//!POPUPS
		//*hide popup
		$(document).on('click', '.dialog-overlay', function (e) {
			$('.dialog2').fadeOut();
			$('.dialog3').fadeOut();
			$('.dialog4').fadeOut();
			$('.dialog-overlay').fadeOut();
		});
		// //*close popup
		// $(document).on('click', '.dialog__close', function (e) {
		// 	$('.dialog').fadeOut();
		// 	$('.dialog-overlay').fadeOut();
		// });
		//*show popup if have already voted
		function showThx2() {
			$('.dialog2').css('top', $(window).scrollTop()+50);
			$('.dialog-overlay').fadeIn();
			$('.dialog2').fadeIn(function () {
				window.setTimeout(function () {
					$('.dialog2').fadeOut(function () {
					});
					$('.dialog-overlay').fadeOut();
				}, 2000);
			});
		}
		//*show popup if incognito
		function showThx3() {
			$('.dialog3').css('top', $(window).scrollTop()+50);
			$('.dialog-overlay').fadeIn();
			$('.dialog3').fadeIn(function () {
				window.setTimeout(function () {
					$('.dialog3').fadeOut(function () {
					});
					$('.dialog-overlay').fadeOut();
				}, 2000);
			});
		}
		//*show popup with thanks
		function showThx4() {
			$('.dialog4').css('top', $(window).scrollTop()+100);
			$('.dialog-overlay').fadeIn();
			$('.dialog4').fadeIn(function () {
				window.setTimeout(function () {
					$('.dialog4').fadeOut(function () {
					});
					$('.dialog-overlay').fadeOut();
					sent=false;
				}, 2000);
			});
		}
		//*show popup voting no started
		// function showThx() {
		// 	$('.dialog__hidable').fadeOut(function () {
		// 		$('.dialog__thx').fadeIn(function () {
		// 			window.setTimeout(function () {
		// 				$('.dialog').fadeOut(function () {
		// 					$('.dialog__thx').hide();
		// 					$('.dialog__hidable').show();
		// 				});
		// 				$('.dialog-overlay').fadeOut();
		// 				sent=false;
		// 			}, 2000);
		// 		});
		// 	});
		// }

		//*show popup end voting
		function showPopupEndVoting() {
			$('.dialog--end-voting').css('top', $(window).scrollTop()+100);
			$('.dialog-overlay').fadeIn();
			$('.dialog--end-voting').fadeIn(function () {
				window.setTimeout(function () {
					$('.dialog--end-voting').fadeOut(function () {
					});
					$('.dialog-overlay').fadeOut();
				}, 5000);
			});
		}



	//!VOTING BUTTONS
	//*button on the nomanation page
	$(document).on('click', '.nominations-vote', function (e) {
		e.preventDefault();

		doctor_id = $(this).parents('.nominations-slider__slide').data('doctor-id');

		if (incognito) {
			showThx3();
			return false;
		}

		if (getCookie('doctor-id-'+doctor_id)!="") {
			showThx2();
			return false;
		}

		$('.vote-form input[name="doctor_id"]').val(doctor_id);
		// $('.dialog input[name="doctor_id"]').val(doctor_id);
		// $('.dialog-overlay').fadeIn();
		// $('.dialog').fadeIn();
		$('.vote-form').submit();
	});

	//*button on the main page
	$(document).on('click', '.circles__ico', function (e) {
		e.preventDefault();
		
		var nom = $(this).data('for-nomination');
		doctor_id = $('[data-nomination="'+nom+'"] .active.center .doctors-slider__slide').data('doctor-id');

		if (incognito) {
			showThx3();
			return false;
		}

		// if (getCookie('doctor-id-'+doctor_id)!="") {
		// 	showThx2();
		// 	return false;
		// }

		$('.vote-form input[name="doctor_id"]').val(doctor_id);
		// $('.dialog input[name="doctor_id"]').val(doctor_id);
		// $('.dialog-overlay').fadeIn();
		// $('.dialog').fadeIn();
		$('.vote-form').submit();
	});




	//!vote form
	//if voting no started or ended
	var votingAvaliable = false;

	$(document).on('submit', '.vote-form', function (e) {
		e.preventDefault();

		if(votingAvaliable){
			console.log('form submited');

			var forSend = $(this).serializeArray();
				var did = forSend.find(function (elem) {return (elem.name=='doctor_id')}).value;
				
				if (!sent) {
					sent = true;
					$.post(this.dataset.action, forSend).done(function (data) {
	
						// setCookie('doctor-id-'+did, 1, 10);
	
						showThx4();
	
						if ($('.nominations-slider__slide').length > 0) {
							var cnt=parseInt($('.nominations-slider .active .socicon__link_inner + .nominations-counter').text());
							cnt++;
							$('.nominations-slider .active .socicon__link_inner + .nominations-counter').text(cnt);
						} else {
							var doctor_id = $('input[name="doctor_id"]').val();
							var cnt = $('.doctors-slider__slide[data-doctor-id="'+doctor_id+'"]').data('cnt');
							cnt++;
							$('.doctors-slider__slide[data-doctor-id="'+doctor_id+'"]').data('cnt',cnt);
							setLikesCount($('.doctors-slider__slide[data-doctor-id="'+doctor_id+'"]').parents('.doctors-slider').get())
						}	
					})
					.fail(function(xhr, status, error) {
						if ((xhr.status==400) && (xhr.responseJSON.msg=='already_voted')) {
							showThx2();
							sent=false;
						} else if(xhr.responseJSON.error){
							console.log('ERROR: ', xhr.responseJSON.msg);
						}
					});
				}
	
			//*if form is full
			// if ($('#iagree').prop('checked')) {
			// 	$('.agree-label').css('color', '#000000');
			// 	$('label[for="iagree"]').css('border', '3px solid #B8860B');
			// 	var forSend = $(this).serializeArray();
			// 	var did = forSend.find(function (elem) {return (elem.name=='doctor_id')}).value;
	
			// 	if (!sent) {
			// 		sent=true;
			// 		$.post('/special/best-likar-2019/vote/',forSend).done(function (data) {
	
			// 			setCookie('doctor-id-'+did, 1, 10);
	
			// 			if ($('.nominations-slider').length>0) {
			// 				var cnt=parseInt($('.nominations-slider .active .socicon__link_inner + .nominations-counter').text());
			// 				cnt++;
			// 				$('.nominations-slider .active .socicon__link_inner + .nominations-counter').text(cnt);
			// 			} else {
			// 				var doctor_id = $('input[name="doctor_id"]').val();
			// 				var cnt = $('.doctors-slider__slide[data-doctor-id="'+doctor_id+'"]').data('cnt');
			// 				cnt++;
			// 				$('.doctors-slider__slide[data-doctor-id="'+doctor_id+'"]').data('cnt',cnt);
			// 				setLikesCount($('.doctors-slider__slide[data-doctor-id="'+doctor_id+'"]').parents('.doctors-slider').get())
			// 			}
	
			// 			showThx();
			// 		})
			// 		.fail(function(xhr, status, error) {
			//     	if ((xhr.status==400) && (xhr.responseJSON.msg=='already_voted')) {
			// 				$('.dialog').fadeOut(function () {
			// 					showThx2();
			// 					sent=false;
			// 				});
			//     	}
			// 		});
			// 	}
			// }
			// else {
			// 	$('.agree-label').css('color', '#FF0000');
			// 	$('label[for="iagree"]').css('border', '3px solid #FF0000');
			// }
		} else {
			showPopupEndVoting();
		}
		
	});



	$(document).on('click', '.doctors-slider__link', function (e) {
		if ($(this).parents('.owl-item.active.center').length==0) {
			e.preventDefault();
			var slide_no = $(this).parents('.doctors-slider__slide').data('slide-no');
			$(this).parents('.doctors-slider').trigger('to.owl.carousel', slide_no);
		}
	});



	$(document).on('click', '.partners__carousel_other .partners__link', function (e) {
		if (!$(this).hasClass('partners__link_active')) {
			e.preventDefault();
			$('.partners__link').removeClass('partners__link_active');
			$(this).addClass('partners__link_active');
		}
	});



	$(document).on('click', '.partners__carousel_partners .partners__link', function (e) {
		if (!$(this).parents('.owl-item').hasClass('center')) {
			e.preventDefault();
			var slide_no = $(this).parents('.partners__item').data('slide-no');
			$('.partners__carousel.partners__carousel_partners').trigger('to.owl.carousel', slide_no);
		}
	});

})(jQuery);


//!submenu for mobile
if (document.body.getBoundingClientRect().width <= 480){
	//*navigation submenu
	const navWithSubmenu = document.querySelector('.menu__item_parent');

	document.body.addEventListener('click', (e) => {

		if ((e.target === navWithSubmenu) || (e.target === navWithSubmenu.children[0])){
			navWithSubmenu.dataset.status === 'active' ?
			navWithSubmenu.dataset.status = ''
			: navWithSubmenu.dataset.status = 'active';
		} else navWithSubmenu.dataset.status = ''
	})
}


//!bubble button
$('.drug-bubble__close').click(function(){
	$('.drug-bubble').fadeOut('fast');
})
